
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.297 24c-.965 0-1.75-.785-1.75-1.75v-8.5c0-.965.785-1.75 1.75-1.75H5.48l2.891-2.79a.749.749 0 011.061.019.751.751 0 01-.019 1.061L7.64 12h8.719l-1.773-1.71A.752.752 0 0115.108 9a.75.75 0 01.521.21L18.52 12h1.183c.965 0 1.75.785 1.75 1.75v8.5c0 .965-.785 1.75-1.75 1.75H4.297zm0-10.5a.25.25 0 00-.25.25v8.5c0 .138.112.25.25.25h15.406a.25.25 0 00.25-.25v-8.5a.25.25 0 00-.25-.25H4.297z"}}),_c('path',{attrs:{"d":"M8.27 21a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75zM12 21a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5A.75.75 0 0112 21zM15.73 21a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75zM11.925 8.625A2.628 2.628 0 019.3 6c0-1.178.772-2.19 1.875-2.516V.75a.75.75 0 011.5 0v3.375a.75.75 0 01-.75.75c-.62 0-1.125.505-1.125 1.125s.505 1.125 1.125 1.125S13.05 6.62 13.05 6a.75.75 0 011.5 0 2.629 2.629 0 01-2.625 2.625z"}})])
          )
        }
      }
    